var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {};

(function ($) {

    CONFUSEDWEBSITE.backToTopLink = function () {
        enquire.register(CSSCONSTANTS.nonMobileMinWidthMQ, {
            match: function () {
                $(window).on('scroll',function () {
                    if ($('.global-nav').offset().top <= $(window).scrollTop()) {
                        $('.back-to-top-link').fadeIn();
                        // getData();
                    } else {
                        $('.back-to-top-link').fadeOut();
                    }
                });

            },
            unmatch: function () {
            }
        }, true);
    };
})(window.jQuery);